import {
  TablerIcon, IconHome2, IconApps, IconDeviceDesktop, IconUsers,
  IconBinaryTree2, IconSteam, IconSettings, IconUser, IconReceipt2,
  IconBuildingStore, IconPlugConnected, IconCopyleft,
} from '@tabler/icons';

import { RouteId, grp } from '../../routes';

export type MenuItem = {
  routeId: RouteId;
  link: string;
  icon: TablerIcon;
  label: string;
  checkPath?: boolean; // true ise link'in path'i ile location.pathname eşleşmeli
  onlyForProjectOwner?: boolean;
};

export const mainMenu: MenuItem[] = [
  {
    routeId: 'homepage',
    link: grp('homepage'),
    icon: IconHome2,
    label: 'Overview',
  },
  {
    routeId: 'applications',
    link: grp('applications'),
    icon: IconApps,
    label: 'Apps',
  },
  {
    routeId: 'licenses',
    link: grp('licenses'),
    icon: IconCopyleft,
    label: 'Licenses',
  },
  {
    routeId: 'devices',
    link: grp('devices'),
    icon: IconDeviceDesktop,
    label: 'Devices',
  },
  {
    routeId: 'employees',
    link: grp('employees'),
    icon: IconUsers,
    label: 'Employees',
  },
  {
    routeId: 'departments',
    link: grp('departments'),
    icon: IconBinaryTree2,
    label: 'Departments',
  },
  {
    routeId: 'vendors',
    link: grp('vendors'),
    icon: IconBuildingStore,
    label: 'Vendors',
  },
  {
    routeId: 'integrations',
    link: grp('integrations'),
    icon: IconPlugConnected,
    label: 'Integrations',
    onlyForProjectOwner: true,
  },
  {
    routeId: 'project-settings',
    link: grp('project-settings', { activeTab: 'teammates' }),
    icon: IconSteam,
    label: 'Teammates',
    checkPath: true,
  },
  {
    routeId: 'project-settings',
    link: grp('project-settings', { activeTab: 'settings' }),
    icon: IconSettings,
    label: 'Project Settings',
    checkPath: true,
    onlyForProjectOwner: true,
  },
];

export const footerMenu: MenuItem[] = [
  {
    routeId: 'account',
    link: grp('account', { activeTab: 'general' }),
    icon: IconUser,
    label: 'Account',
    checkPath: true,
  },
  {
    routeId: 'account',
    link: grp('account', { activeTab: 'billing' }),
    icon: IconReceipt2,
    label: 'Billing',
    checkPath: true,
  },
];
